import { render, staticRenderFns } from "./AddRoleNumber.vue?vue&type=template&id=c666a3d8&scoped=true&"
import script from "./AddRoleNumber.vue?vue&type=script&lang=js&"
export * from "./AddRoleNumber.vue?vue&type=script&lang=js&"
import style0 from "./AddRoleNumber.vue?vue&type=style&index=0&id=c666a3d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c666a3d8",
  null
  
)

export default component.exports